import { AnalyzerEntity } from '@telespot/domain';

export enum IState {
  ANALYZED = 'analyzed',
  READ = 'read',
  INPROGRES = 'inProgress',
}

export interface IAnalysisState {
  id: string;
  analystId: string;
  analystEntity: AnalyzerEntity;
  state: IState;
  reference: boolean;
  bookmarkAssetId: string;
  favouriteAssetIds: string[];
  name?: string;
  updatedAt?: Date;
}
